// must use 
const Trendingphotos =() => {
return [
{
    id:"Freedom",
    title:"Freedom Photos",
    image:"/assets/images/Trending/1.jpeg"
},
{
    id:"Recycle",
    title :"Recycling",
    image:"/assets/images/Trending/2.jpeg"

},
{
    id:"Flower",
    title:"Flower Images",
    image:"/assets/images/Trending/3.jpeg"

},
{
    id:"Christmas",
    title:"Christmas 2022",
    image:"/assets/images/Trending/4.jpeg"

},
{
    id:"Analog",
    title:"Analog Photos",
    image:"/assets/images/Trending/5.jpeg"

},
{
    id:"Smile",
    title:"Smile Images",
    image:"/assets/images/Trending/6.jpeg"

},
{
    id:"Body",
    title:"Body Positive",
    image:"/assets/images/Trending/7.jpeg"

},
{
    id:"Selfies",
    title:"Selfies Photos",
    image:"/assets/images/Trending/8.jpeg"

},
{
    id:"Tote-Bag",
    title:"Tote Bag Mockup",
    image:"/assets/images/Trending/9.jpeg"

}
]
}
export default Trendingphotos;